import React from 'react';
import styles from './Text.module.scss'

const Text = (props) => {
    const { variant, children } = props
    
    const setVariantStyle = (variant) => {

        switch(variant){
            case 'paragraph-gray-italic': return styles.gray
            case 'editor-error': return styles.editorError
            default: return styles.paragraph
        }

    }

    return (
        <div className={setVariantStyle(variant)}>
            {children}
        </div> 
    );
}
export default Text;